import React, { useState } from 'react';
import api from '../api';
import './LoginPage.css';

export interface FleetUser {
  name: string;
  email: string;
  rolle: string;
}

interface LoginPageProps {
  onLogin: (token: string, user: FleetUser) => void;
}

const LoginPage: React.FC<LoginPageProps> = ({ onLogin }) => {
  const [email, setEmail] = useState('');
  const [passwort, setPasswort] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const res = await api.post('/api/auth/login', { email, passwort });
      const { access_token, name, email: userEmail, rolle } = res.data;
      const user: FleetUser = { name, email: userEmail, rolle };
      localStorage.setItem('fleet_token', access_token);
      localStorage.setItem('fleet_user', JSON.stringify(user));
      onLogin(access_token, user);
    } catch (err: any) {
      const status = err.response?.status;
      const detail = err.response?.data?.detail;
      if (status === 423) {
        setError(detail || 'Konto gesperrt. Bitte spaeter erneut versuchen.');
      } else {
        setError(detail || 'E-Mail oder Passwort falsch.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-inner">
        <div className="login-intro">
          <span className="login-eyebrow">Fleet / Control-Plane</span>
          <h1 className="login-h1">Steuern Sie Ihre <em>Instanzen</em>.</h1>
          <p className="login-lede">
            Ein Zugang fuer alle Kundenstacks — Rollout, Backups und Status
            auf einen Blick.
          </p>
          <div className="login-claim">DSGVO by default — Made in Germany</div>
        </div>

        <div className="login-frame">
          <span className="k-corner k-corner--tl">{'// fleet / zugang'}</span>
          <span className="k-corner k-corner--tr">control-plane</span>
          <span className="k-corner k-corner--bl">verschluesselt</span>
          <span className="k-corner k-corner--br">intern</span>

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="login-field">
              <label>E-Mail</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="name@agenticerp.io"
                required
                autoFocus
              />
            </div>
            <div className="login-field">
              <label>Passwort</label>
              <input
                type="password"
                value={passwort}
                onChange={e => setPasswort(e.target.value)}
                placeholder="••••••••"
                required
              />
            </div>

            {error && <div className="login-error">{error}</div>}

            <button className="login-btn" type="submit" disabled={loading}>
              {loading ? 'Anmeldung …' : 'Anmelden'} <span className="arr">→</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
